import * as actionTypes from "../constants";

import type { RecoveredEncountersState, UpdateRecoveredCountPayload } from "../models";

const createEmptyEncounterRecovery = (): RecoveredEncountersState => ({
  recoveredEncountersTotal: 0,
  totalFacility: 0,
  totalPractice: 0,
  loading: false,
});

export const recoveredEncountersReducer = (state = createEmptyEncounterRecovery(), action) => {
  switch (action.type) {
    case actionTypes.GET_RECOVERED_ENCOUNTERS_BEGIN:
      return handleGetRecoveredEncountersBegin(state);
    case actionTypes.GET_RECOVERED_ENCOUNTERS_ERROR:
      return handleGetRecoveredEncountersError(state, action.payload);
    case actionTypes.UPDATE_RECOVERED_ENCOUNTERS_TOTAL:
      return handleUpdateRecoveredEncountersTotal(state, action.payload);
    default:
      return state;
  }
};

const handleGetRecoveredEncountersBegin = (state: RecoveredEncountersState) => ({
  ...state,
  loading: true,
});

const handleGetRecoveredEncountersError = (state: RecoveredEncountersState, payload: string) => ({
  ...state,
  errorText: payload,
  loading: false,
});

const handleUpdateRecoveredEncountersTotal = (
  state: RecoveredEncountersState,
  payload: UpdateRecoveredCountPayload,
) => {
  const newState: RecoveredEncountersState = {
    ...state,
    ...payload,
  };

  return {
    ...newState,
    recoveredEncountersTotal: newState.totalFacility + newState.totalPractice,
  };
};
